import { render, staticRenderFns } from "./OrderDate.vue?vue&type=template&id=225c113e&scoped=true"
import script from "./OrderDate.vue?vue&type=script&lang=js"
export * from "./OrderDate.vue?vue&type=script&lang=js"
import style0 from "./OrderDate.vue?vue&type=style&index=0&id=225c113e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c113e",
  null
  
)

export default component.exports